import { render, staticRenderFns } from "./ManageColourDialog.vue?vue&type=template&id=1bd13dd2"
import script from "./ManageColourDialog.vue?vue&type=script&lang=js"
export * from "./ManageColourDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports